import { Check, Clock, ShieldAlertIcon, CircleDashed, CircleOff } from 'lucide-react';

import { IconBadgeVerified, IconBadgeValidated, IconBadgeCertified } from 'src/components/Svg/Images';
import { AppCertificationTypeEnum } from 'src/graphql/schema';
import { productTypeMap } from 'src/shared/mappings/productTypeMap';

import type { ApplicationFilters } from './types';

export type FilterOptionTone = 'teal' | 'red' | 'green';

export type FilterSectionOption = {
  value: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  iconSize?: string;
  exclusive?: boolean;
  tone?: FilterOptionTone;
};

export type FilterSectionConfig = {
  key: keyof ApplicationFilters;
  title: string;
  options: FilterSectionOption[];
};

export const FILTER_SECTIONS: FilterSectionConfig[] = [
  {
    key: 'setupStatus',
    title: 'Setup status',
    options: [
      { value: 'needs_finishing', label: 'Needs finishing', icon: Clock, tone: 'teal' },
      { value: 'no_protection_yet', label: 'No protection yet', icon: CircleDashed, tone: 'teal' },
    ],
  },
  {
    key: 'tasks',
    title: 'Tasks',
    options: [
      { value: 'with_tasks', label: 'With tasks', icon: ShieldAlertIcon, tone: 'red' },
      { value: 'all_clear', label: 'No tasks', icon: Check, exclusive: true, tone: 'green' },
    ],
  },
  {
    key: 'productIncluded',
    title: 'Product included',
    options: Object.entries(productTypeMap).map(([value, { label, icon }]) => ({
      value,
      label,
      icon,
      iconSize: 'size-5.5',
    })),
  },
  {
    key: 'assuranceReached',
    title: 'Assurance reached',
    options: [
      { value: AppCertificationTypeEnum.Validated, label: 'Validated', icon: IconBadgeValidated, iconSize: 'size-5.5' },
      { value: AppCertificationTypeEnum.Verified, label: 'Verified', icon: IconBadgeVerified, iconSize: 'size-5.5' },
      { value: AppCertificationTypeEnum.Certified, label: 'Certified', icon: IconBadgeCertified, iconSize: 'size-5.5' },
      { value: AppCertificationTypeEnum.None, label: 'None', icon: CircleOff, tone: 'red' },
    ],
  },
];
